import * as styles from '/ui/components/marketingactivationpage/marketingactivationpage.module.scss';

export const LISTINGS_ASSET = <ListingsAsset className={styles.image}/>;

function ListingsAsset({className}) {
  const assetName = 'listings-map.mp4';
  const urlArray = window.location.pathname.split('/');
  const imageUrl = `/${urlArray[1]}/public/images/${assetName}`;
  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      autoPlay
      playsInline
      muted
      loop
      height="308px"
      src={imageUrl}
      className={className}/>
  );
}
